// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__+ihpa","footerContent":"Footer_footerContent__QyXXU","footerHeader":"Footer_footerHeader__VdTvj","footerBtn":"Footer_footerBtn__6rWD5"};